import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Landing from '@/module/Landing/page/WebLogin.vue';
import Home from '@/module/Home/page/Home.vue';
//reward
import Reward from '@/module/Reward/page/Reward.vue';
import RewardCategory from '@/module/Reward/page/RewardCategory.vue';
import RewardCampaign from '@/module/Reward/page/RewardCampaign.vue';
import RewardDetail from '@/module/Detail/page/Campaign.vue';
//search
import RewardSearchAlive from '@/module/Reward/page/RewardSearchAlive.vue';
import RewardSearch from '@/module/Reward/page/RewardSearch.vue';

import History from '@/module/History/page/History.vue';
import Profile from '@/module/Profile/page/Profile.vue';
import AboutUs from '@/module/Static/page/About.vue';
import FAQ from '@/module/Static/page/Faq.vue';
//basic
import ErrorPage from '@/module/Error/page/Error.vue';
//gift
import Gift from '@/module/Gift/page/Gift.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/landing',
            name: 'landing',
            component: Landing
        },
        {
            path: '/',
            name: 'home default',
            component: Home
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/reward',
            name: 'reward',
            component: Reward,
            children: [
                {
                    path: '/reward/:catId',
                    name: 'reward category',
                    component: RewardCategory
                },
                {
                    path: '/reward/:catId/sub/:subCatId',
                    name: 'reward campaign',
                    component: RewardCampaign
                },
                {
                    path: '/reward/detail/:campaignId',
                    name: 'reward detail',
                    component: RewardDetail
                }
            ]
        },
        {
            path: '/search',
            name: 'search',
            component: RewardSearchAlive,
            children: [
                {
                    path: '/search',
                    name: 'search list',
                    component: RewardSearch,
                },
                {
                    path: '/search/:campaignId',
                    name: 'search detail',
                    component: RewardDetail,
                }
            ]
        },
        {
            path: '/history/:type',
            name: 'history',
            component: History
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile
        },
        {
            path: '/about',
            name: 'about',
            component: AboutUs
        },
        {
            path: '/faq',
            name: 'faq',
            component: FAQ
        },
        {
            path: '/error/:code',
            name: 'error-code',
            component: ErrorPage
        },
        {
            path: '/error/:api/:id',
            name: 'error',
            component: ErrorPage
        },
        {
            path: '/gift',
            name: 'gift',
            component: Gift
        },
    ]
})
